module.exports = __webpack_public_path__ + "media/assets/images/flags/va-7e7608f3ddc87e47c11a7256cb7683ae.svg";